/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Packing_Photo_Upload_ErrorInputs */

const vi_toast_packing_photo_upload_error = /** @type {(inputs: Toast_Packing_Photo_Upload_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải ảnh lên thất bại, vui lòng thử lại`)
};

/**

* @param {Toast_Packing_Photo_Upload_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_packing_photo_upload_error = /** @type {((inputs?: Toast_Packing_Photo_Upload_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Packing_Photo_Upload_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_packing_photo_upload_error(inputs)
});